<div class="step-content">
    <div class="step-header">
        <h2>Sign documents</h2>
    </div>

    <div class="documents-grid">
        <ng-container *ngFor="let doc of documents; let i = index;">
            @if (!doc.hide) {
                <div class="document-card">
                        <div class="document-icon">
                            <img src="{{doc.srcUrl}}" alt="Document icon">
                        </div>
                        <h3 class="document-title">{{ doc.title }}</h3>
                        @if(doc.id == DocumentTypes.W9){
                            <p class="document-subtitle">{{ doc.subtitle }}</p>
                        } @else {
                            <p class="empty-document-subtitle"></p>
                        }
                        <div class="document-actions">
                            @if(doc.id == DocumentTypes.W9) {
                                @if(doc.isSigned){
                                    <app-button class="btn-mgr search-btn-claim" [label]="'Delete'" [isDisabled]="impersonatedUser"
                                        [isFilled]="false" [buttonType]="'primary'" (click)="onDeleteDocument(this.documentsMap['W9'][0], i)"
                                        id="signDocument"></app-button>
                                    <app-button class="btn-mgr search-btn-claim" [label]="'Download'"
                                        [isFilled]="false" [buttonType]="'primary'" (click)="onViewDocument(this.documentsMap['W9'][0], false)"
                                        id="signDocument"></app-button>                        
                                }
                                @if(!doc.isSigned){
                                    <app-button class="btn-mgr search-btn-claim" [label]="'Upload'" [isDisabled]="impersonatedUser"
                                        [isFilled]="false" [buttonType]="'primary'" (click)="triggerFileSelect()"
                                        id="signDocument"></app-button>
                                    <app-upload-trigger #w9Uploader [accept]="accept" (fileSelected)="onUploadDocument($event, i)"></app-upload-trigger>
                                }
                            } @else {
                                @if(doc.id != DocumentTypes.UniformRequirements){
                                <app-button class="btn-mgr search-btn-claim" [label]="doc.isSigned ? 'Signed ✓' : 'Read & Sign'"
                                    [isFilled]="false" [buttonType]="'primary'"
                                    (click)="doc.isSigned ? null : onReadAndSign(doc)"
                                    id="signDocument"></app-button>
                                }
                                @if(doc.isSigned || doc.id == DocumentTypes.UniformRequirements) {
                                <app-button class="btn-mgr search-btn-claim" [label]="'View'"
                                    [isFilled]="false" [buttonType]="'primary'" (click)="onReadAndSign(doc)"
                                    id="viewDocument"></app-button>
                                }
                            }
                        </div>
                        <div class="document-actions">
                            @if(doc.id == DocumentTypes.UniformRequirements){
                            <div class="attestations-form">
                                <label [ngClass]="{
                                    'disableCheckbox': !isUniformRequirementsRead, 
                                    'checkbox-option': isUniformRequirementsRead,
                                    'disableAction': impersonatedUser,
                                }">
                                    <app-checkbox id="termsCheckBox" layout='horizontal' [for]="'termsCheckBox-input'"
                                        (click)="doc.isSigned ? null : enableReviewed()"
                                        [checkboxLabels]="[checkboxLabel]"
                                        [formGroup]="termscheckForm"></app-checkbox>
                                </label>
                                <div class="error-message" *ngIf="confirmationCheckbox">
                                    You must certify to proceed
                                </div>
                                <div class="error-message" *ngIf="showNotReviewed">
                                    Please confirm you reviewed the Uniform requirements
                                </div>
                            </div>
                            }
                        </div>
                </div>
            }
         </ng-container> 
    </div>

    <app-wizard-navigation [showBack]="true" [showNext]="true" (back)="onBack()"
        (next)="onNext()" (cancel)="onCancel()" [showNextOnly]="true">
    </app-wizard-navigation>
</div>